let context: AudioContext | null = null;

const PATTERNS: Record<string, number[]> = {
  order_review_required: [660, 880],
  order_follow_required: [523, 659],
  order_shipped: [659, 784, 988],
  order_stock_ready: [523, 659, 784, 1047],
  order_stock_recovered: [523, 659, 784, 1047],
  order_stock_partially_recovered: [523, 659, 523],
  order_change_review_required: [880, 660, 880],
  order_change_pending: [520, 420],
  order_change_approved: [659, 784, 988],
  order_change_ack_required: [740, 740, 988],
  order_change_direct: [784, 587, 784, 988],
  order_change_rejected: [440, 330],
};

export async function playNotificationTone(soundKey = 'order_review_required') {
  if (!context) context = new window.AudioContext();
  await context.resume();
  const pattern = PATTERNS[soundKey] || PATTERNS.order_review_required;
  const startAt = context.currentTime;
  pattern.forEach((frequency, index) => {
    const oscillator = context!.createOscillator();
    const gain = context!.createGain();
    const start = startAt + index * 0.19;
    oscillator.type = soundKey.includes('stock') ? 'sine' : 'triangle';
    oscillator.frequency.setValueAtTime(frequency, start);
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.12, start + 0.025);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.16);
    oscillator.connect(gain);
    gain.connect(context!.destination);
    oscillator.start(start);
    oscillator.stop(start + 0.17);
  });
}

export function speakNotification(message: string) {
  if (!('speechSynthesis' in window)) return;
  const utterance = new SpeechSynthesisUtterance(message);
  utterance.lang = 'zh-CN';
  window.speechSynthesis.speak(utterance);
}
